import React, { useEffect, useRef, useState } from 'react';
import { useT } from '../../i18n';

/**
 * Language dropdown.
 *  - variant="dark" → for placement on a dark/colored bar (Landing hero nav before scroll)
 *  - variant="light" → for placement on a normal app surface (Layout sidebar, scrolled nav)
 */
export default function LanguageSwitcher({ variant = 'light', compact = false }) {
  const { lang, setLang, languages, t } = useT();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  const current = languages.find(l => l.code === lang) || languages[0];
  const isDark = variant === 'dark';

  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <button
        onClick={() => setOpen(o => !o)}
        title={t('common.language')}
        style={{
          background: isDark ? 'rgba(255,255,255,0.1)' : 'transparent',
          border: isDark ? '1px solid rgba(255,255,255,0.18)' : '1px solid var(--border)',
          color: isDark ? '#fff' : 'var(--text)',
          cursor: 'pointer', padding: compact ? '4px 8px' : '7px 12px',
          borderRadius: 8, fontSize: 13, fontWeight: 500, fontFamily: 'inherit',
          display: 'flex', alignItems: 'center', gap: 6,
        }}
      >
        <span style={{ fontSize: 14 }}>{current.flag}</span>
        {!compact && <span>{current.nativeName}</span>}
        <span style={{ fontSize: 9, opacity: 0.7 }}>▾</span>
      </button>

      {open && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 6px)', right: 0,
          background: 'var(--card-bg)', border: '1px solid var(--border)',
          borderRadius: 10, boxShadow: 'var(--shadow-md)',
          minWidth: 180, padding: 4, zIndex: 1000,
        }}>
          {languages.map(l => {
            const active = l.code === lang;
            return (
              <button
                key={l.code}
                onClick={() => { setLang(l.code); setOpen(false); }}
                style={{
                  width: '100%', textAlign: 'left',
                  background: active ? 'var(--hover-bg)' : 'transparent',
                  border: 'none', cursor: 'pointer',
                  padding: '8px 12px', borderRadius: 6, fontFamily: 'inherit',
                  display: 'flex', alignItems: 'center', gap: 10,
                  color: 'var(--text)', fontSize: 13,
                }}
              >
                <span style={{ fontSize: 16 }}>{l.flag}</span>
                <span style={{ flex: 1 }}>{l.nativeName}</span>
                {active && <span style={{ color: 'var(--success)', fontSize: 12 }}>✓</span>}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
